<template>
  <div id="app">
    <div class="bg_video" v-if="play">
      <div class="pointer" v-if="!isAuto"><img src="@/assets/img/pointer.png" alt="">点击屏幕播放视频</div>
      <video id="bgvideo" src="@/assets/bg.mp4" playsinline="false"  x5-video-player-type="h5"   autoplay="autoplay"></video>
    </div>
    <router-view v-else>
    </router-view>
    <div class="icons">
      <div :class="['icon','bg_music',{'active':isPlay}]" @click="playAudio"><img src="@/assets/img/volume.png" alt=""></div>
      <div class="icon like" @click="onLike"><img v-if="like" src="@/assets/img/zan_on.png" alt=""><img v-else src="@/assets/img/zan.png" alt=""> <transition name="likeAddAnimate"><span v-show="islike">+1</span></transition></div>
    </div>
  </div>
</template>

<script>
import "../static/css.css"
export default {
  name: 'App',
  data() {
    return {
      play:true,
      isPlay:false,
      bgmusic:new Audio(require('@/assets/bg.mp3')),
      like:false,
      islike:false,
      isAuto:false,
    }
  },
  methods: {
    playAudio() {          
      if(this.isPlay){
          this.bgmusic.pause();
          this.isPlay = false;
      }else {
          this.bgmusic.play();
          this.isPlay = true;
      }
    },
    onLike() {
      this.like = true;
      this.islike = true;
       setTimeout(() => {
          this.islike = false;
        }, 1500);
    }
  },
  mounted() {
    var _this = this;
    if(this.$route.path=='/'){
      this.play = true;
    }else {
      this.play = false
    }
  this.$nextTick(()=>{   
        document.getElementById('bgvideo').play();
      })
      document.addEventListener('click',function(){
          document.getElementById('bgvideo').play();
          _this.isAuto = true;
      })
      document.getElementById('bgvideo').addEventListener('ended', () => { //该视频播放是否已结束
          this.play = false;       
        }, false)
  },
}
</script>

<style>
html,body {
  width:100%;
  height:100%;
}
* {
  margin:0;
  padding:0;
  list-style:none;
}
img {
  max-width:100%;
}
#app {
  width:100%;
}
  .bg_video {
      position:absolute;
      width:100%;
      height:193vw;
      top:0;
      z-index:1;
      background:#000;
  }
  .pointer {
    position:absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
    margin:auto;
    display:flex;
    flex-direction: column;
    justify-content:center;
    align-items:center;
    color:#fff;
    text-align:center;
    font-size:12px;
    font-family: "simkai";
  }
  .pointer img {
    width:8.5vw;
  }
  .bg_video video {
      max-width:100%;
      max-height:100%;
  }
  .icons {
    position:fixed;
    right:10px;
    top:20px;
    background:rgba(146,104,71,0.2);
    background:radial-gradient(#fdefaf 50%,#f7be48);
    padding:5px;
    border-radius:8px;
    box-shadow: inset 0px 0px 2px 0px #c88c38;
  }
  .icons .icon {
    position:relative;
    width:3.8vw;
  }
  .icons .icon:nth-child(1) {
    margin-bottom:20px;
  }
  .like span {
    color: #fca736;
    position: absolute;
    top: 10px;
    width: 100%;
    text-align: center;
    font-size:10px;
    left:0;
  }
  .likeAddAnimate-enter-active,
.likeAddAnimate-leave-active {
  transition: all 1.5s ease;
}

.likeAddAnimate-enter,
.likeAddAnimate-leave {
  transform: translateY(0) scale(0);
  opacity: 0;
}

.likeAddAnimate-enter-to,
.likeAddAnimate-leave-to {
  transform: translateY(-30px) scale(1.2);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue